import css from "styled-jsx/css";

export const ModuloCaracteristicasCss = css`
  .moduloCaracteristicas {
    margin: 20px 0px !important;

    .title {
      text-align: center;
    }
    .featureList {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      align-items: flex-start;

      > div {
        flex: 1 0 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;

        .span {
          font-size: 18px;
          font-family: getScssValue("gp", "light-font") !important;
          margin: 0px;
        }
        .svgIL {
          display: block;
        }
        > span > span {
          padding-bottom: 10px;
        }
      }
    }

    @media screen and (max-width: 768px) {
      .featureList {
        > div {
          width: 100%;
          .span {
            font-size: 16px;
          }
        }
      }
    }
  }
`;
